__webpack_require__.p = "/acquisition-contracts-routes/referrals-hub/";